export default {
  map: new Map(),
}
